<template>
    <div class="widget-title">
        <div class="title-content" @click="startTitleEdit">
            <template v-if="!isEditingTitle">
                <span class="title-text">{{ widget.title }}</span>
                <i class="material-icons edit-icon">edit</i>
            </template>
            <a-input
                v-else
                ref="titleInput"
                v-model="editingTitle"
                :defaultValue="widget.title"
                @pressEnter="saveTitleEdit"
                @blur="saveTitleEdit"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { TABLE_API } from "../../../../../../../api/table";

export default Vue.extend({
    name: "WidgetTitle",
    props: {
        widget: {
            type: Object,
            required: true
        },
        table: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isEditingTitle: false,
            editingTitle: ''
        };
    },
    methods: {
        startTitleEdit() {
            this.editingTitle = this.widget.title;
            this.isEditingTitle = true;
            this.$nextTick(() => {
                this.$refs.titleInput.focus();
            });
        },
        async saveTitleEdit() {
            if (this.editingTitle.trim() && this.editingTitle !== this.widget.title) {
                try {
                    await TABLE_API.updateWidget(
                        this.table._id,
                        this.widget.page,
                        this.widget._id,
                        {
                            title: this.editingTitle
                        }
                    );
                    this.$emit('widget-updated', {
                        ...this.widget,
                        title: this.editingTitle
                    });
                } catch (error) {
                    console.error('Widget başlığı güncellenirken hata:', error);
                    this.$message.error('Widget başlığı güncellenirken bir hata oluştu');
                    this.editingTitle = this.widget.title;
                }
            } else {
                this.editingTitle = this.widget.title;
            }
            this.isEditingTitle = false;
        }
    }
});
</script>

<style scoped lang="scss">
.widget-title {
    font-weight: 500;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
    max-width: 70%;

    .title-content {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 4px 8px;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
            background: rgba(0, 0, 0, 0.04);

            .edit-icon {
                opacity: 1;
            }
        }
    }

    .title-text {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .edit-icon {
        font-size: 16px;
        opacity: 0;
        color: rgba(0, 0, 0, 0.45);
        transition: opacity 0.2s;
        flex-shrink: 0;
    }

    .ant-input {
        font-size: 14px;
        padding: 2px 8px;
        height: 28px;
        width: 100%;
    }
}
</style> 